

export default function CheckOnlinePaymentRefundStatus(refundStatus) {

    if(refundStatus == 0){
        return "Not Applicable"
    }
    else if(refundStatus == 1){
        return "Pending"
    }
    else if(refundStatus == 2){
        return "Initialized"
    }
    else if(refundStatus == 3){
        return "Success"
    }
    else if(refundStatus == 4){
        return "Failed"
    }
    else if(refundStatus == 4){
        return "Cancelled"
    }
    else if(refundStatus == 5){
        return "Applicable"
    }
    else{
        return "No Status Available"
    }

}

const PHONEPAY_REFUND_STATUS = Object.freeze({
  NOT_APPLICABLE: 0,
  REFUND_PENDING: 1,
  REFUND_INITIATED: 2,
  REFUND_SUCCESS: 3,
  REFUND_FAILED: 4,
  REFUND_APPLICABLE: 5
})

